import { Component, OnInit } from '@angular/core';
import { PackageDataService } from '../../data-services/package.service';
import { MessageService } from 'primeng/api';

@Component({
   selector: 'app-package-check',
   templateUrl: './package.check.html',
   providers: [MessageService]
})
export class PackageCheckComponent implements OnInit {

   constructor(private packageDataService: PackageDataService) {
   }

   packages: any[];
   goButtonDisabled: boolean = false;

   ngOnInit() {
      this.packageDataService.getPackagesToCheck().subscribe((data: any) => {
         this.packages = data;
      });
   }

   checkPackage(index) {
      this.goButtonDisabled = true;
      this.packageDataService.checkPackageRequisitions(this.packages[index].PackageId).subscribe((data: any) => {
         this.packages[index].RequisitionCount = data.RequisitionCount;
         this.packages[index].AlreadySent = data.AlreadySent;
         this.packages[index].SuccessfullySent = data.SuccessfullySent;
         this.packages[index].Unsuccessful = data.Unsuccessful;

         if ((index + 1) < this.packages.length) {
            setTimeout(() => this.checkPackage(index + 1), 1000);
         } else {
            this.goButtonDisabled = false;
         }
      });
   }
}
